// extracted by mini-css-extract-plugin
module.exports = {"title":"bundleTile_title__SlUqg","add":"bundleTile_add__NhP7R"};